import styled from "styled-components/macro";

import { colors } from "UI/colors";

export const SlotsTakenCount = styled.div`
  display: inline-block;
  font-size: 10px;
  font-weight: 800;
  background: blue;
  color: #fff;
  padding: 1px 5px;
  border-radius: 6px;
  background-color: ${colors.fnTabSelectedGray};
`;
